import { Margin } from '@spritz-finance/ui'
import styled from 'styled-components'

export const GlassCard = styled.div`
    display: flex;
    flex-direction: column;
    background: var(
        --surface-1,
        linear-gradient(
            123.85deg,
            rgba(255, 255, 255, 0.85) 16.92%,
            rgba(255, 255, 255, 0.35) 85.33%
        )
    );

    box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    padding: ${Margin.Med};
`
